import NFTHeader from "@/components/NFTHeader";
import React, {useEffect, useState} from "react";
import Styles from './index.module.scss'
import {hideLoading, showLoading} from "@/components/loading";
import JsBridgeNew from "@/utils/jsbridgeNew";
import appService from "@/utils/appService";
import Service from "@/view/culturalExchange/service";
import {Toast} from "antd-mobile";
import {objectToQueryParams} from "@/utils/publicFun";
import qs from "query-string";
import Empty from "@/components/empty";
import { copyText} from "@/utils/publicFun"
import {useNavigate} from "react-router-dom";

/**
 * @description 藏品权益领取
 * @return {/culturalExchange/thirteenGuards}
 */
const GetGuardsBenefit = () => {
  const [data, setData] = useState({isPick: false, isCollection: true, goodsOrderInfo: {}})
  const { nftNo,activityCode} = qs.parse(window.location.search);
  const [data2, setData2] = useState([])//G优权益
  const [xunfengdata,setXunfengdata] = useState([])//巽风权益
  const [shiwuThing, setShiwuThing] = useState({})//G优实物
  const [greenCarbonData,setGreenCarbonData] = useState([])//绿碳藏品活动数据
  const [greenCarbonShiwu,setGreenCarbonShiwu] = useState([])//绿碳藏品活动实物

  const [show,setShow] = useState(false)//兑换弹窗
  const [exchangeCode,setExchangeCode] = useState("")//兑换码
  const navigate = useNavigate();
  const getData = async (isRefresh = false) => {
    try {
      // isRefresh && showLoading();
      const userInfo = await JsBridgeNew.getCurrentUserInfo();
      if(activityCode === 'carbonCredit'){
        //绿碳藏品活动
        const data = [{id:1,goodsName:'碳信用',imgUrl:require('@/assets/img/culturalExchange_greencarbon/greenCarbon@2x.png')},
          {id:2,goodsName:'绿地酒店权益',imgUrl:require('@/assets/img/culturalExchange_greencarbon/greenhotel@2x.png')}]
        setData2(data)
      }else{
        const res2 = await appService("600114",{
          activityCode: activityCode,
          clientId: userInfo?.clientId,
          collectionId: userInfo?.collectionId,
          nftNo,
        }, false);
        if(activityCode === 'moutaiCb' || activityCode === 'moutaiCb2'){
          console.log('res2===>', res2.data)
          const l1 = [];//GU群益
          const l2 = [];//藏品权益
          res2.data.map((item,index)=>{
            if(item?.platform === '0'){
              l1.push(item)
            }else{
              l2.push(item)
            }
          })
          if(l1.length > 0){
            const shiwu = l1.find(item => item?.goodsType === 3)
            console.log('shiwu===>', shiwu)
            setShiwuThing(shiwu)
          }
          setData2(l1)
          setXunfengdata(l2)
        }else if(activityCode === 'TaijiCarbon'){
          console.log('res33333===>', res2?.data.filter(item => item?.goodsType === 10 || item?.goodsType === 6))
          if(res2?.data?.length > 0){
            const shiwu = res2.data.find(item => item?.goodsType === 3)
            console.log('shiwu===>', shiwu)
            const shiwuList = [];//实物权益
            if(shiwu){
              setShiwuThing(shiwu)
              shiwuList.push(shiwu)
              setGreenCarbonShiwu(shiwuList)
            }
          }
          setGreenCarbonData(res2?.data.filter(item => item?.goodsType === 10 || item?.goodsType === 6))
        }else{
          if(res2?.data?.length > 0){
            const shiwu = res2.data.find(item => item?.goodsType === 3)
            console.log('shiwu===>', shiwu)
            if(shiwu){
              setShiwuThing(shiwu)
            }else{
              if(activityCode === 'horseYearInvite'){
                console.log('shiwu22222===>', res2.data[0])
                setShiwuThing(res2.data[0])
              }
            }
          }
          setData2(res2.data)
          
          // setXunfengdata(res2.data)
        }
      }
      // 亚运碳活动空投藏品权益只有碳权益无需查询领取情况
      if(activityCode !== 'AsianGamesCarbon') {
        const res = await appService("600926",{
          activityCode: activityCode,
          clientId: userInfo?.clientId,
          nftNo,
        }, false);
        setExchangeCode(res.data.redeemCode)
        setData(res.data)
        console.log('600926===>', res.data)
      }
      isRefresh && hideLoading();
    } catch (error) {
      console.log(error)
      isRefresh && hideLoading();
      Toast.show(error);
    }
  }
  useEffect(() => {
    getData(true)
  }, []);
  const onDidFocus = () => {
    window.JsBridge.addListener().then(() => {
      getData();
    });
  }
  const handleToOrder = async (item,type) => {
    if(type === 1 && !data?.expired) {
      Toast.show('领取时间已结束')
      return
    }
    if(data?.isPick) {
      const param = objectToQueryParams({
        id: item?.id,
        phone: item?.phone,
        prizeImgUrl: item?.productImgUrl,
        prizeName: item?.productName,
        prizeType: item?.productType,
        skuId: shiwuThing?.goodsId,
        createTime: item?.createTime,
        consigneeName: item?.consigneeName,
        consigneeNumber: item?.consigneeNumber,
        province: item?.province,
        city: item?.city,
        area: item?.area,
        street: item?.street,
        address: item?.address,
        deliverStatus:item?.deliverStatus,
        deliverGoods:item?.deliverGoods||0,
        logCo:item?.logCo||"",
        trackNo:item?.trackNo||"",
        shipDate:item?.shipDate||"",
        orderId:item?.orderId||"",
        needShowCount:1,
        isnoShiwu:activityCode === 'horseYearInvite'?1:0,
        shiwuThingGoodsName:shiwuThing.goodsName,
        shiwuThingimgUrl:shiwuThing.imgUrl,
      });
      window.JsBridge.push('CustomWeb', { uri: `${process.env.REACT_APP_GKT_LINK}/front/activities/lottery/orderDetail?${param}`});
    }else {
      const userInfo = await JsBridgeNew.getCurrentUserInfo();
      const param = objectToQueryParams({
        idf: 'exchangeCultural',
        activityCode: activityCode,
        req: shiwuThing?.id,
        name: shiwuThing?.goodsName,
        imgUrl: shiwuThing?.imgUrl,
        productId:shiwuThing?.goodsId,
        isChangeName:0,
        clientId: userInfo?.clientId,
        skUId: shiwuThing?.goodsId,
        prizeImgUrl: shiwuThing?.imgUrl,
        prizeName: shiwuThing?.goodsName,
        nftNo: nftNo,
        needShowCount:1,
        isnoShiwu:activityCode === 'horseYearInvite'?1:0,
      });
      window.JsBridge.push('CustomWeb', { uri:`${process.env.REACT_APP_GKT_LINK}/front/guapp/activityOrder?${param}`});
      onDidFocus();
    }
  }
  const getExchangeCode = async () =>{

    const userInfo = await JsBridgeNew.getCurrentUserInfo();
    const res = await appService("600933",{
      activityCode: activityCode,
      clientId: userInfo?.clientId,
      nftNo,
    }, false);
    console.log('res888888===>', res)
    if(res?.data?.redeemCode?.length > 0){
      setExchangeCode(res?.data?.redeemCode)
      setShow(true)
      getData(false)
    }
  }
  const toExchange = async () =>{
    //前往巽风兑换
    const url = `https://xwindlab.com/app?webviewPath=https%3A%2F%2Fshop-h5.xwindlab.com%2FsubPackages%2Fcollection%2Fjointly%2Findex%3FredeemCode%3D${encodeURIComponent(exchangeCode)}`;
    window.JsBridge.link(url)
  }
  const toMyCollection = () => {
    const url = `/culturalExchange_greencarbon/collectionRecord`
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.push("CustomWeb", { uri: `${window.location.origin}${url}` });
    } else {
      navigate(url);
    }
  }
  const toMyCollectiontaiji = () => {
    const url = `/culturalExchange_taijigreencarbon/collectionRecord`
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.push("CustomWeb", { uri: `${window.location.origin}${url}` });
    } else {
      navigate(url);
    }
  }
  const toGreenCarbon = async () =>{
    const userInfo = await JsBridgeNew.getCurrentUserInfo();
    const res = await appService("600936",{
      activityCode: 'carbonCredit',
      clientId: userInfo?.clientId,
      nftNo,
    }, false);
    if (res.status > 0) {
      // const url = `https://wx4a359c7b9ddf878b.wx.gcihotel.net/wechat/?/#/dianziquan?gameCode=GIHG_a52eed2225d649629a5b&isOpenShare=F`;
      // window.JsBridge.link(url)
      toGreenCarbonDetail()
    }

  }
  const toGreenCarbonTaiji = async () =>{
    const userInfo = await JsBridgeNew.getCurrentUserInfo();
    const res = await appService("600936",{
      activityCode: 'TaijiCarbon',
      clientId: userInfo?.clientId,
      nftNo,
    }, false);
    if (res.status > 0) {
      // const url = `https://wx4a359c7b9ddf878b.wx.gcihotel.net/wechat/?/#/dianziquan?gameCode=GIHG_a52eed2225d649629a5b&isOpenShare=F`;
      // window.JsBridge.link(url)
      toGreenCarbonDetailTaiji()
    }

  }
  const toGreenCarbonDetailTaiji = async () =>{
    // const url = `https://wx4a359c7b9ddf878b.wx.gcihotel.net/wechat/?/#/dianziquan?gameCode=GIHG_a52eed2225d649629a5b&isOpenShare=F`;
    const url = `https://wx4a359c7b9ddf878b.wx.gcihotel.net/wechat/?/#/dianziquanApp?gameCode=09bee80b4d5e43efadca`;
    window.JsBridge.link(url)
  }
  const toGreenCarbonDetail = async () =>{
    // const url = `https://wx4a359c7b9ddf878b.wx.gcihotel.net/wechat/?/#/dianziquan?gameCode=GIHG_a52eed2225d649629a5b&isOpenShare=F`;
    const url = `https://wx4a359c7b9ddf878b.wx.gcihotel.net/wechat/?/#/dianziquanNew?gameCode=LDJKC&isOpenShare=F&debugMode=T`;
    window.JsBridge.link(url)
  }
  return (
    <div className={Styles.getGuardsBenefit}>
      <NFTHeader
        midText="藏品权益领取"
        bgColor="#FFFFFF"
      />
      <div className={Styles.benefitGrid}>
        {greenCarbonData.map((item, index) => (
          <div 
            key={item.id} 
            className={`${Styles.benefitCard} ${data?.outPick ? Styles.disabled :''}`}
          >
            <div className={Styles.cardIcon}>
              <img src={item?.imgUrl} alt={item?.goodsName} />
              {data?.outPick && <div className={Styles.claimedOverlay}>已领取</div>}
            </div>
            <div className={Styles.cardTitle}>{item?.goodsName}</div>
            <div className={Styles.btnBox}>
              {index === 0&& <button onClick={toMyCollectiontaiji} className={Styles.btn}>请至绿碳申请中操作</button>}
              {index === 1&&!data?.outPick && <button onClick={toGreenCarbonTaiji} className={data?.expired ? Styles.btn : Styles.btn_gray}>领取权益</button>}
              {index === 1&&data?.outPick && data?.outPerson && <button onClick={toGreenCarbonDetailTaiji} className={Styles.btn}>已领取 查看详情</button>}
            </div>
          </div>
        ))}
      </div>
      {activityCode==='TaijiCarbon'&&greenCarbonShiwu.length>0?<div className={Styles.title3}></div>:null}
      <div className={Styles.benefitGrid}>
        {activityCode==='TaijiCarbon'&&greenCarbonShiwu.map((item, index) => (
          <div 
            key={item.id} 
            className={`${Styles.benefitCard} ${data?.isPick ? Styles.disabled :''}`}
          >
            <div className={Styles.cardIcon}>
              <img src={item?.imgUrl} alt={item?.goodsName} />
              {data?.isPick && <div className={Styles.claimedOverlay}>已领取</div>}
            </div>
            <div className={Styles.cardTitle}>{item?.goodsName}</div>
            <div className={Styles.btnBox}>
              {!data?.isPick && <button onClick={() => handleToOrder(data?.goodsOrderInfo,1)} className={data?.expired ? Styles.btn : Styles.btn_gray}>领取权益</button>}
              {data?.isPick && data?.isPerson && <button onClick={() => handleToOrder(data?.goodsOrderInfo,2)} className={Styles.btn}>查看详情</button>}
            </div>
          </div>
        ))}
      </div>
      {xunfengdata&&xunfengdata.length>0?<div className={Styles.title1}></div>:null}
      <div className={Styles.benefitGrid}>
        {data2.map((item, index) => (
          <div 
            key={item.id} 
            className={`${Styles.benefitCard} ${item?.goodsName !== '碳信用'?(data?.isPick ? Styles.disabled : ''):''}`}
          >
            <div className={Styles.cardIcon}>
              <img src={item?.imgUrl} alt={item?.goodsName} />
              {item?.goodsName !== '碳信用'&&data?.isPick && <div className={Styles.claimedOverlay}>已领取</div>}
            </div>
            <div className={Styles.cardTitle}>{item?.goodsName}</div>
            <div className={Styles.btnBox}>
              {activityCode === 'AsianGamesCarbon' && <button onClick={toMyCollection} className={Styles.btn}>请至绿碳申请中操作</button>}
              {activityCode === 'carbonCredit'&&index === 0&& <button onClick={toMyCollection} className={Styles.btn}>请至绿碳申请中操作</button>}
              {activityCode === 'carbonCredit'&&index === 1&&!data?.isPick && <button onClick={toGreenCarbon} className={data?.expired ? Styles.btn : Styles.btn_gray}>领取权益</button>}
              {activityCode === 'carbonCredit'&&index === 1&&data?.isPick && data?.isPerson && <button onClick={toGreenCarbonDetail} className={Styles.btn}>查看详情</button>}
            </div>
          </div>
        ))}
      </div>
      {activityCode !== 'AsianGamesCarbon' && (
        <div className={Styles.btnBox}>
          {activityCode !== 'airPort'&&activityCode !== 'carbonCredit'&&activityCode !== 'TaijiCarbon'&&!data?.isPick && <button onClick={() => handleToOrder(data?.goodsOrderInfo,1)} className={data?.expired ? Styles.btn : Styles.btn_gray}>领取权益</button>}
          {activityCode !== 'airPort'&&activityCode !== 'carbonCredit'&&activityCode !== 'TaijiCarbon'&&data?.isPick && data?.isPerson && <button onClick={() => handleToOrder(data?.goodsOrderInfo,2)} className={Styles.btn}>查看详情</button>}
          {activityCode === 'airPort'&&activityCode !== 'carbonCredit'&&activityCode !== 'TaijiCarbon'&&!data?.outPick && <button onClick={getExchangeCode} className={data?.expired ? Styles.btn : Styles.btn_gray}>领取权益</button>}
          {activityCode === 'airPort'&&activityCode !== 'carbonCredit'&&activityCode !== 'TaijiCarbon'&&data?.outPick &&data?.outPerson && <button onClick={() => setShow(true)} className={Styles.btn}>已领取 查看兑换码</button>}
        </div>
      )}
      {xunfengdata&&xunfengdata.length>0?<div className={Styles.title2}></div>:null}
      <div className={Styles.benefitGrid}>
        {xunfengdata.map((item, index) => (
          <div 
            key={item.id} 
            className={`${Styles.benefitCard} ${data?.outPick ? Styles.disabled : ''}`}
          >
            <div className={Styles.cardIcon}>
              <img src={item?.imgUrl} alt={item?.goodsName} />
              {data?.outPick && <div className={Styles.claimedOverlay}>已领取</div>}
            </div>
            <div className={Styles.cardTitle}>{item?.goodsName}</div>
          </div>
        ))}
      </div>
      {xunfengdata&&xunfengdata.length>0?<div className={Styles.btnBox}>
        {!data?.outPick && <button onClick={getExchangeCode} className={data?.expired ? Styles.btn : Styles.btn_gray}>领取权益</button>}
        {data?.outPick &&data?.outPerson && <button onClick={() => setShow(true)} className={Styles.btn}>已领取 查看兑换码</button>}
      </div>:null}
      
      {
        show?<div className={Styles.exchangemodal}>
        <div className={Styles.modelShadow} onClick={()=>setShow(false)}></div>
        <div className={Styles.content1}>
            <div className={Styles.title}>兑换码</div>
            <div className={Styles.close} onClick={()=>setShow(false)}></div>
            <div className={Styles.codebox}>
                <div className={Styles.codecontext}>{exchangeCode}</div>
                <div className={Styles.copybtn} id="copyURL" onClick={() => copyText(exchangeCode|| "", document.getElementById("copyURL"))}></div>
            </div>
            {activityCode !== 'airPort' && <div className={Styles.confirmBtn} >
              <button className={Styles.confirmBtnTitle} onClick={toExchange}>前往巽风兑换</button>
            </div>}
            {activityCode === 'airPort' && <div className={Styles.hintText}>请复制兑换码前往「在机场」app 兑换</div>}
        </div>
    </div>:null
      }

      
    </div>
  )
}
export default GetGuardsBenefit
